import { render } from "./MoveColumnPrompt.vue?vue&type=template&id=9e4d16d6&ts=true"
import script from "./MoveColumnPrompt.vue?vue&type=script&lang=ts"
export * from "./MoveColumnPrompt.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__